import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideMenu } from './components/side-menu/side-menu';
import { NavBar } from './components/nav-bar/nav-bar';
import { Toast } from './components/toast/toast';
import { ConsentBanner } from './components/consent-banner/consent-banner';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SideMenu, NavBar, Toast, ConsentBanner],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('creator');

  constructor() {
    inject(AnalyticsService).init();
  }
}
